// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject4":"QuizApp-module--seeLiveProject4--1YlNX","sourceCodeProject4":"QuizApp-module--sourceCodeProject4--2m6B4"};